import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Action, LinkButton } from '../ui';
import { QuoteForm, AcceptQuote } from '../QuoteForms';

function requestAction(rfq, user) {
  if (rfq.status === 'ordered') return 'orders';
  if (user.approval !== 'approved') return 'none';
  if (user.role === 'buyer' && rfq.status === 'quoted') return 'accept';
  if (user.role === 'supplier' && ['open', 'quoted'].includes(rfq.status)) return 'quote';
  return 'none';
}

const SupplierQuoteAction = ({ rfq, reload }) => {
  const [revise, setRevise] = useState(false);
  const onSuccess = () => { setRevise(false); reload(); };
  if (!rfq.quote || revise) return <QuoteForm rfq={rfq} onSuccess={onSuccess} />;
  return <Action id={`revise-quote-${rfq.id}`} secondary onClick={() => setRevise(true)}>Revise quotation</Action>;
};

export const RequestActions = ({ rfq, user, reload }) => {
  switch (requestAction(rfq, user)) {
    case 'orders': return <LinkButton id={`rfq-view-order-${rfq.id}`} to="/workspace/orders" secondary>
      View purchase orders<ArrowUpRight size={15} /></LinkButton>;
    case 'accept': return <AcceptQuote rfq={rfq} onSuccess={reload} />;
    case 'quote': return <SupplierQuoteAction rfq={rfq} reload={reload} />;
    default: return null;
  }
};